export default __webpack_public_path__ + "static/media/icon-logout.8c0704ce.svg";